exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-0d33bb2e] {\n  display: -webkit-box;\n  display: flex;\n}", ""]);

// exports
